import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import { groupByMonth } from '@jumbo/utils/formatHelpers';
import { redColor } from 'config';

function ReportUnitCountTable({ data, showWithDates }) {
  const { baseFontSize } = useTemplateFontSettings()

  const groupedData = groupByMonth(data);

  return (
    <>
      {Object.keys(groupedData).map((monthName) => (
        <div key={monthName}>
          <h4 style={{
            fontSize: baseFontSize + 2,
            fontWeight: 'bold',
            marginTop: 20,
            marginBottom: 10,
            color: redColor,
            borderBottom: `2px solid ${redColor}`,
            paddingBottom: 5
          }}>
            {monthName}
          </h4>
          <Table size="small"
            sx={{ marginBottom: 3, marginTop: 1, borderRadius: 3, lineHeight: 1, fontSize: baseFontSize }}>
            <TableHead sx={{ backgroundColor: "lightgrey" }}>
              <TableRow>
                <TableCell align="left" sx={{ fontSize: baseFontSize }}>Kurum</TableCell>
                <TableCell align="left" sx={{ fontSize: baseFontSize }}>Kurul/Kol/Komisyon Adı</TableCell>
                {showWithDates && (
                  <TableCell align="left" sx={{ fontSize: baseFontSize }}>Tarihler</TableCell>
                )}
                <TableCell align="left" sx={{ fontSize: baseFontSize }}>Toplantı Sayısı</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groupedData[monthName].map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.inst}</TableCell>
                  <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.unitName}</TableCell>
                  {showWithDates && (
                    <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.meetingDates || '-'}</TableCell>
                  )}
                  <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.meetingCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </>
  );
}

export default ReportUnitCountTable;